import { Box, Button, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import TableHeader from '../../common/TableHeader'
import { useParams, useSearchParams } from 'react-router-dom'
import api from '../../../service/api'
import { formatDate, Icons } from '../../../utils/utilities'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import noExamImg from '../../../assets/noexams.svg'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import AuditQuizViewer from '../quizzes/AuditQuizViewer'
import CustomTable from '../../common/custom-table/CustomTable'

const columns = [
    { field: "index", width: "100px", index: true, name: "Sl. no.", align: "center", rowPadding: "10px 20px" },
    { field: "title", width: "150px", name: "Quiz Title" },
    { field: "created_on", width: "130px", name: "Created on", renderCell: item => formatDate( item.created_at ), },
    { field: "subject", width: "200px", name: "Subject", renderCell: item => item?.subject?.subject_name || "Not Available" },
    { field: "instances", name: "Instances", align: "center" },
]

const QuizDetails = ( { userData } ) => {

    const [error, setError] = useState( null )
    const [loading, setLoading] = useState( true )
    const [quizDetails, setQuizDetails] = useState( [] )
    const [selectedQuiz, setSelectedQuiz] = useState( null )

    const { empcode } = useParams()
    const [searchParams] = useSearchParams( { legacy: true } )
    const legacy = searchParams.get( 'legacy' ) === 'true'

    const { palette, layout } = useTheme()

    const handleDialogClose = ( refresh = false ) => {
        setSelectedQuiz( null )
        if ( refresh )
            loadQuizzes()
    }

    const loadQuizzes = useCallback( async () => {
        setLoading( true )
        try {
            const { data: { data } } = await api.audit.getQuizzesByFacultyId( empcode, { legacy } )
            setQuizDetails( data )
            setError( false )
        } catch ( err ) {
            setError( err?.response?.data?.message || "Something went wrong while fetching assignments details." )
        } finally {
            setLoading( false )
        }
    }, [empcode, legacy] )

    useEffect( () => {
        loadQuizzes()
    }, [loadQuizzes] )

    return (
        <Box maxHeight="350px" display="flex" flexDirection="column" overflow="hidden">

            {selectedQuiz && <AuditQuizViewer quiz={selectedQuiz} handleClose={handleDialogClose} openState={Boolean( selectedQuiz )} />}

            {/* Data */}
            {!loading && !error && quizDetails.length > 0 && <CustomTable onRowClick={item => setSelectedQuiz( item )} columns={columns} data={quizDetails} />}

            {/* Loading */}
            {loading && !error && <Box padding="50px 20px" display="flex" justifyContent="center">
                <DataLoadingSpinner waitingMessage="Please wait! Loading quizzes..." />
            </Box>}

            {/* Error */}
            {error && <TryAgainMessageBlock getData={loadQuizzes} loading={loading} err={error} />}

            {/* No Data */}
            {!loading && !error && quizDetails.length === 0 && <Box borderRadius={layout.borderRadius} bgcolor={palette.contentBg} padding="20px" gap="20px" display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                <img src={noExamImg} height="100px" alt="Something went wrong!" />
                <Typography variant="subtitle2"><em>{userData.employee_name}</em> hasn't given any quizzes!</Typography>
                <Button disabled={loading} onClick={loadQuizzes} startIcon={Icons.default.Replay} variant="outlined" sx={{ textTransform: "capitalize" }} color="secondary">Fetch again</Button>
            </Box>}
        </Box>
    )
}

export default QuizDetails
